<template>
  <v-app class="app">
    <!-- <AppDrawer v-if="!nonDrawer.includes($route.name)" />
    <AppDrawer />
    <v-content>
      <router-view />
    </v-content>
     -->
    <component :is="layout">
      <router-view />
    </component>
    
  </v-app>
</template>

<script>
import AppHeader from "./components/AppHeader";
import AppFooter from "./components/AppFooter";
import AppDrawer from "./components/AppDrawer";
import SnackNotification from "@/components/SnackNotification.vue";
const default_layout = "default";
const regeneratorRuntime = require("regenerator-runtime");

export default {
  name: "App",
  components: {
    AppHeader,
    AppFooter,
    AppDrawer,
    SnackNotification,
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    },
  },
};
</script>

<style>
.v-main{
  height: 100%;
  Overflow: hidden;
}
.app {
  font-family: 'Fira Sans', sans-serif;
}
.no-col{
  flex-basis: auto;
}
</style>
